/**
 * Preload hints for the homepage hero image (LCP element).
 * Mirrors the <picture> sources rendered in src/components/home/HeroV3.tsx.
 */
export const HERO_PRELOAD: Array<Record<string, string>> = [
  {
    rel: "preload",
    as: "image",
    type: "image/avif",
    href: "/images/hero-car-bright-1536.avif",
    imageSrcSet:
      "/images/hero-car-bright-768.avif 768w, /images/hero-car-bright-1536.avif 1536w",
    imageSizes: "(max-width: 767px) 100vw, 1536px",
    fetchPriority: "high",
  },
];
